import Cookies from 'js-cookie';
import { axios } from 'lib/axios';

export const loginWithSMSOTP = () => {
  const token = Cookies.get('token');
  return axios.get('/user/sms/sendCode', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
